import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import { Form, Input, Row, Col, DatePicker, Divider, Modal } from 'antd';

import { FormButtons, SelectOptions } from '../../../commonComponents';

import moment from 'moment';

const FormItem = Form.Item;

const REGEX_FISCAL_CODE = /^(?:(?:[B-DF-HJ-NP-TV-Z]|[AEIOU])[AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[1256LMRS][\dLMNP-V])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i;
const REGEX_PIVA = /^[0-9]{11}$/i;
const REGEX_POSTALCODE = /^[0-9]{5}$/i;

@withRouter
@inject(
  'translationsStore',
  'step1RegistrationStore',
  'countriesStore',
  'provincesStore',
  'citiesStore',
  'vehicleInformationStore',
  'usersStore',
  'registrationStore'
)
@observer
class Step_1_Form extends Component {
  constructor(props) {
    super(props);
    this.state = { techAutofilled: true };

    if (!this.props.step1RegistrationStore.session) {
      this.props.history.push('/registrations');
    }
  }

  setFieldsValue() {
    this.props.form.setFieldsValue(this.props.step1RegistrationStore.formValues);
  }

  componentDidMount() {
    this.setFieldsValue();
    this.setState({ isragsoc: !!this.props.form.getFieldValue('user.ragsoc') });
  }

  trimValue = value => (typeof value === 'string' ? value.trim() : value);

  handlerOnBlurTrim = field => e => {
    const rawValue = e && e.target ? e.target.value : e;
    let trimmedValue = this.trimValue(rawValue);

    if (field === 'user.email' && typeof trimmedValue === 'string') {
      trimmedValue = trimmedValue.toLowerCase();
    }

    this.props.step1RegistrationStore.setFormField(field, trimmedValue);
    this.props.form.setFieldsValue({ [field]: trimmedValue });

    if (field === 'user.ragsoc') {
      this.setState({ isragsoc: !!trimmedValue }, () => {
        this.props.form.validateFields(['user.firstname', 'user.lastname', 'user.birthday'], { force: true });
      });
    }
  };

  handlerOnSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.step1RegistrationStore
          .submit()
          .then(() => {
            if (this.props.step1RegistrationStore.status > 1) {
              this.props.history.push('/registration/step_3');
              this.props.vehicleInformationStore.loadModels();
              this.props.vehicleInformationStore.loadTypes();
            }
          })
          .catch(error => {
            let errorObj = { title: 'Unknown error' };
            if (error) Object.assign(errorObj, { title: error.name }, { content: error.details[0].message });
            Modal.error(errorObj);
          });
      } else {
        console.log(err);
      }
    });
  };

  handlerOnChange = field => e => {
    const value = typeof e === 'string' ? e : e.target.value;
    this.props.step1RegistrationStore.setFormField(field, value);
    if (field === 'user.country') {
      this.props.step1RegistrationStore.setFormField('user.prov', '');
      this.props.step1RegistrationStore.setFormField('user.city', '');
    }
    if (field === 'user.prov') {
      this.props.step1RegistrationStore.setFormField('user.city', '');
    }
    this.setFieldsValue();
  };

  handlerOnChangeBirthday = (date, dateString) => {
    this.props.step1RegistrationStore.setFormField('user.birthday', date);
    this.setFieldsValue();
  };

  handlerOnChangeRegistrationYear = (date, dateString) => {
    this.props.step1RegistrationStore.setFormField('car.matriculationYear', date);
    this.setFieldsValue();
  };

  handlerOnSelectMaker = codiceMarca => {
    const maker = this.props.vehicleInformationStore.makers.find(m => m.codiceMarca === codiceMarca);
    this.props.step1RegistrationStore.setFormField('car.make.codiceMarca', codiceMarca);
    this.props.step1RegistrationStore.setFormField('car.make.descrizione', maker.descrizione);
    this.props.step1RegistrationStore.setFormField('car.model.codiceModello');
    this.props.step1RegistrationStore.setFormField('car.model.descrizione');
    this.props.step1RegistrationStore.setFormField('car.type.codiceInfocarAM');
    this.props.step1RegistrationStore.setFormField('car.type.descrizione');
    this.setFieldsValue();
  };

  handlerOnSelectModel = codiceModello => {
    const model = this.props.vehicleInformationStore.models.find(m => m.codiceModello === codiceModello);
    this.props.step1RegistrationStore.setFormField('car.model.codiceModello', codiceModello);
    this.props.step1RegistrationStore.setFormField('car.model.descrizione', model.descrizione);
    this.props.step1RegistrationStore.setFormField('car.type.codiceInfocarAM');
    this.props.step1RegistrationStore.setFormField('car.type.descrizione');
    this.setFieldsValue();
  };

  handlerOnSelectType = codiceInfocarAM => {
    const { loadInfocar: f1, getFuelTypeByAlias: f2, getEngineTypeBySize: f3, types } = this.props.vehicleInformationStore;
    const type = types.find(m => m.codiceInfocarAM === codiceInfocarAM);
    this.props.step1RegistrationStore.setFormField('car.type.codiceInfocarAM', codiceInfocarAM);
    this.props.step1RegistrationStore.setFormField('car.type.descrizione', type.descrizione);
    this.setState({ techAutofilled: true }); // ottimistico: riparte disabled finché non si sa

    const { registrationStore } = this.props;
    const vehicleType = registrationStore.vehicleType ? registrationStore.vehicleType : 'car';

    f1(codiceInfocarAM, vehicleType)
      .then(infocar => {
        // Infocar può risolvere anche senza dati (200 vuoto, 401 → undefined):
        // consideriamo "autofillato" solo se abbiamo davvero i due valori.
        const alimentation = infocar && infocar.alimentation ? f2(infocar.alimentation) : undefined;
        const displacement = infocar && infocar.displacement ? f3(infocar.displacement) : undefined;
        const autofilled = !!(alimentation && displacement);
        this.props.step1RegistrationStore.setFormField('car.alimentation', alimentation);
        this.props.step1RegistrationStore.setFormField('car.displacement', displacement);
        this.setState({ techAutofilled: autofilled }); // false → sblocca per compilazione manuale
        this.setFieldsValue();
      })
      .catch(() => {
        // Infocar giù / auto nuova: pulisci i valori stantii e sblocca i due select
        // per la compilazione manuale dal libretto.
        this.props.step1RegistrationStore.setFormField('car.alimentation');
        this.props.step1RegistrationStore.setFormField('car.displacement');
        this.setState({ techAutofilled: false });
        this.setFieldsValue();
      });
  };

  handlerOnChangeRegistrationOdometer = e => {
    let odo = e.target.value;
    //console.log(Math.max(parseInt(odo), 0));
    this.props.step1RegistrationStore.setFormField('car.registrationOdometer', Math.max(parseInt(odo, 10), 0));
    this.setFieldsValue();
  };

  handlerOnChangeOtherColor = e => {
    this.props.step1RegistrationStore.setFormField('car.color', e.target.value);
    this.setFieldsValue();
  };

  isValid = () => {
    return false;
  };

  requiredRule = label => {
    return {
      required: true,
      message: `The field [${label}] is required`
    };
  };

  isRagsocPresent = () => this.props.form.getFieldValue('user.ragsoc') && this.props.form.getFieldValue('user.ragsoc').trim();

  withDecorator = (name, label, fieldDecoratorOptions) => {
    return component => (
      <Col className={'fieldElement fieldElement-' + name}>
        <FormItem label={label} colon={false}>
          {fieldDecoratorOptions ? this.props.form.getFieldDecorator(name, fieldDecoratorOptions)(component) : component}
        </FormItem>
      </Col>
    );
  };

  Step_1RquiredBasicInputField = (
    name,
    label,
    {
      onChange = this.handlerOnChange(name),
      onBlur,
      placeholder,
      type,
      disabled = this.props.step1RegistrationStore.inProgress,
      rules = []
    }
  ) =>
    this.Step_1BasicInputField(name, label, {
      onChange,
      onBlur,
      placeholder,
      type,
      disabled,
      rules: [this.requiredRule(label), ...rules]
    });

  Step_1BasicInputField = (
    name,
    label,
    {
      onChange = this.handlerOnChange(name),
      onBlur = this.handlerOnBlurTrim(name),
      placeholder,
      type,
      disabled = this.props.step1RegistrationStore.inProgress,
      rules = []
    }
  ) =>
    this.withDecorator(name, label, {
      rules: [...rules]
    })(
      <Input
        type={type || 'text'}
        placeholder={placeholder || label}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
      />
    );

  Step_1SelectCountries = (label, { onChange = this.handlerOnChange('user.country'), placeholder, disabled = this.props.step1RegistrationStore.inProgress }) => {
    const { countriesList: countries } = this.props.countriesStore;
    return this.withDecorator('user.country', label, {
      rules: [this.requiredRule(label)]
    })(
      <SelectOptions
        style={{ width: '174px' }}
        placeholder={placeholder || label}
        onChange={onChange}
        disabled={disabled}
        options={countries.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))}
      />
    );
  };

  Step_1SelectProvinces = (label, { onChange = this.handlerOnChange('user.prov'), placeholder, disabled = this.props.step1RegistrationStore.inProgress }) => {
    const { provincesList: provinces } = this.props.provincesStore;
    return this.withDecorator('user.prov', label, {
      rules: [this.requiredRule(label)]
    })(
      <SelectOptions
        style={{ width: '174px' }}
        placeholder={placeholder || label}
        onChange={onChange}
        disabled={disabled}
        options={provinces.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))}
      />
    );
  };

  Step_1SelectCities = (label, { onChange = this.handlerOnChange('user.city'), placeholder, disabled = this.props.step1RegistrationStore.inProgress }) => {
    const { citiesList: cities } = this.props.citiesStore;
    return this.withDecorator('user.city', label, {
      rules: [this.requiredRule(label)]
    })(
      <SelectOptions
        style={{ width: '174px' }}
        placeholder={placeholder || label}
        onChange={onChange}
        disabled={disabled}
        options={
          this.props.form.getFieldValue('user.country') === 'IT' && this.props.form.getFieldValue('user.prov') !== undefined
            ? cities
                .filter(city => city.prov_code === this.props.form.getFieldValue('user.prov'))
                .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
            : []
        }
      />
    );
  };

  render() {
    const { current: t } = this.props.translationsStore;
    const { step1RegistrationStore } = this.props;

    const { makers, models, types, fuelSupplyTypes, engineSizes, vehicleColors } = this.props.vehicleInformationStore;

    return (
      <Form name="step_1" onSubmit={this.handlerOnSubmit} style={{ width: '100%' }}>
        <Divider orientation="left">{t['registration_1']['headerUser']}</Divider>
        <Row type="flex" style={{ flexWrap: 'wrap' }} justify="start">
          {this.Step_1BasicInputField('user.ragsoc', t['shared']['lblCompanyName'], {
            onChange: e => {
              this.handlerOnChange('user.ragsoc')(e);
              this.setState({ isragsoc: !!(e.target.value && e.target.value.trim()) }, () => {
                this.props.form.validateFields(['user.firstname', 'user.lastname', 'user.birthday'], { force: true });
              });
            },
            onBlur: this.handlerOnBlurTrim('user.ragsoc')
          })}

          {this.Step_1BasicInputField('user.firstname', t['shared']['lblFirstName'], {
            disabled: this.props.step1RegistrationStore.inProgress,
            rules: [
              {
                required: !this.state.isragsoc || this.state.isragsoc
              },
              {
                validator: (rule, value, callback) => {
                  try {
                    if (/\d/.test(value)) {
                      throw new Error('Payments processors will check for fictional names');
                    }
                    callback();
                  } catch (err) {
                    callback(err);
                  }
                },
                message: t['shared']['lblFoundSomeInvalidCharacters']
              }
            ]
          })}
          {this.Step_1BasicInputField('user.lastname', t['shared']['lblSurname'], {
            disabled: this.props.step1RegistrationStore.inProgress,
            rules: [
              {
                required: !this.state.isragsoc || this.state.isragsoc
              },
              {
                validator: (rule, value, callback) => {
                  try {
                    if (/\d/.test(value)) {
                      throw new Error('Payments processors will check for fictional names');
                    }
                    callback();
                  } catch (err) {
                    callback(err);
                  }
                },
                message: t['shared']['lblFoundSomeInvalidCharacters']
              }
            ]
          })}

          {this.withDecorator('user.birthday', `${t['shared']['lblBirthday']}`, {
            rules: [
              {
                required: !this.state.isragsoc,
                message: `The field ${t['shared']['lblBirthday']} is required`
              }
            ]
          })(
            <DatePicker
              disabled={this.props.step1RegistrationStore.inProgress || this.state.isragsoc}
              onChange={this.handlerOnChangeBirthday}
              format={this.props.translationsStore.longDateFormat.L}
              disabledDate={date => date > moment().subtract(18, 'years')}
              placeholder={this.props.translationsStore.longDateFormat.L}
            />
          )}

          {this.Step_1RquiredBasicInputField('user.address', t['shared']['lblAddress'], {
            placeholder: t['shared']['placeholderAddres']
          })}

          {this.Step_1RquiredBasicInputField('user.number', t['shared']['lblAddressNumber'], {
            onBlur: this.handlerOnBlurTrim('user.number')
          })}

          {this.Step_1RquiredBasicInputField('user.postcode', t['shared']['lblPostcode'], {
            onBlur: this.handlerOnBlurTrim('user.postcode'),
            rules: [
              {
                type: 'string',
                pattern: REGEX_POSTALCODE,
                message: `The field is not a valid cap`
              }
            ]
          })}

          {this.Step_1SelectCountries(t['shared']['lblCountry'], {})}

          {this.props.form.getFieldValue('user.country') === 'IT'
            ? this.Step_1SelectProvinces(t['shared']['lblProv'], {})
            : this.Step_1RquiredBasicInputField('user.prov', t['shared']['lblProv'], {})}

          {this.props.form.getFieldValue('user.country') === 'IT'
            ? this.Step_1SelectCities(t['shared']['lblCity'], {})
            : this.Step_1RquiredBasicInputField('user.city', t['shared']['lblCity'], {})}

          {!(this.props.form.getFieldValue('user.ragsoc') && this.props.form.getFieldValue('user.ragsoc').trim()) &&
            this.Step_1BasicInputField('user.personalcode', t['shared']['lblTaxCode'], {
              rules: [
                {
                  required: true,
                  message: `The field [${t['shared']['lblTaxCode']}] is required`
                },
                {
                  type: 'string',
                  pattern: REGEX_FISCAL_CODE,
                  message: `The field is not a valid fiscal code`
                }
              ]
            })}

          {this.props.form.getFieldValue('user.ragsoc') &&
            this.props.form.getFieldValue('user.ragsoc').trim() &&
            this.Step_1BasicInputField('user.personalcode', t['shared']['lblVatNumber'], {
              rules: [
                {
                  required: true,
                  message: `The field [${t['shared']['lblVatNumber']}] is required`
                },
                {
                  type: 'string',
                  pattern: REGEX_PIVA,
                  message: `The field is not valid partita iva`
                }
              ]
            })}

          {this.Step_1RquiredBasicInputField('user.email', t['shared']['lblEmail'], {
            type: 'email',
            rules: [{ type: 'email', messagge: `not a valid email` }],
            onChange: e => {
              this.props.step1RegistrationStore.setFormField('user.email', e.target.value.toLowerCase());
              this.setFieldsValue();
            },
            onBlur: this.handlerOnBlurTrim('user.email')
          })}

          {this.Step_1RquiredBasicInputField('user.mobile', t['shared']['lblMobile'], {
            onBlur: this.handlerOnBlurTrim('user.mobile'),
            rules: [
              {
                type: 'string',
                pattern: /\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{8,14}$/,
                message: 'not a valid phone number (+391231245789)'
              }
            ]
          })}

          {this.Step_1BasicInputField('user.secondaryMobile', t['shared']['lblSecondaryMobile'], {
            onBlur: this.handlerOnBlurTrim('user.secondaryMobile'),
            rules: [
              {
                type: 'string',
                pattern: /\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{8,14}$/,
                message: 'not a valid phone number (+391231245789)'
              }
            ]
          })}
        </Row>

        <Divider orientation="left">{t['registration_1']['headerVehicle']}</Divider>

        <Row type="flex" style={{ flexWrap: 'wrap' }} justify="start">
          {this.withDecorator('car.make.codiceMarca', t['shared']['lblMaker'], {
            rules: [this.requiredRule(t['shared']['lblMaker'])]
          })(
            <SelectOptions
              style={{ minWidth: '200px' }}
              placeholder={t['shared']['lblMaker']}
              onChange={this.handlerOnSelectMaker}
              disabled={!step1RegistrationStore.isCarDetailEnabled}
              options={makers}
              optionValue={'codiceMarca'}
              optionContent={'descrizione'}
            />
          )}

          {this.withDecorator('car.make.descrizione', '', {})(<Input type="hidden" />)}

          {this.withDecorator('car.model.codiceModello', t['shared']['lblModel'], {
            rules: [this.requiredRule(t['shared']['lblModel'])]
          })(
            <SelectOptions
              style={{ minWidth: '174px' }}
              placeholder={t['shared']['lblModel']}
              onChange={this.handlerOnSelectModel}
              disabled={!step1RegistrationStore.isCarDetailEnabled}
              options={models}
              optionValue={'codiceModello'}
              optionContent={'descrizione'}
            />
          )}

          {this.withDecorator('car.model.descrizione', '', {})(<Input type="hidden" />)}

          {this.withDecorator('car.type.codiceInfocarAM', t['shared']['lblType'], {
            rules: [this.requiredRule(t['shared']['lblType'])]
          })(
            <SelectOptions
              style={{ minWidth: '400px' }}
              placeholder={t['shared']['lblType']}
              onChange={this.handlerOnSelectType}
              disabled={!step1RegistrationStore.isCarDetailEnabledLight}
              options={types}
              optionValue={'codiceInfocarAM'}
              optionContent={'descrizioneCompleta'}
            />
          )}

          {this.withDecorator('car.type.descrizione', '', {})(<Input type="hidden" />)}

          {this.Step_1RquiredBasicInputField('car.casenumber', t['shared']['lblVin'], {
            disabled: !step1RegistrationStore.isCarDetailEnabled
          })}

          {this.withDecorator('car.alimentation', t['shared']['lblPower'], {
            rules: [this.requiredRule(t['shared']['lblPower'])]
          })(
            <SelectOptions
              style={{ minWidth: '174px' }}
              placeholder={t['shared']['lblPower']}
              onChange={this.handlerOnChange('car.alimentation')}
              disabled={this.state.techAutofilled}
              options={fuelSupplyTypes}
              optionValue={'type'}
              optionContent={'name'}
            />
          )}

          {this.withDecorator('car.displacement', t['shared']['lblCC'], {
            rules: [this.requiredRule(t['shared']['lblCC'])]
          })(
            <SelectOptions
              style={{ minWidth: '174px' }}
              placeholder={t['registration_1']['lblCCOption1']}
              onChange={this.handlerOnChange('car.displacement')}
              disabled={this.state.techAutofilled}
              options={engineSizes}
              optionValue={'type'}
              optionContent={'name'}
            />
          )}

          {this.withDecorator('car.matriculationYear', `${t['shared']['lblCarRegistration']}`, {
            rules: [this.requiredRule(t['shared']['lblCarRegistration'])]
          })(
            <DatePicker
              onChange={this.handlerOnChangeRegistrationYear}
              format={this.props.translationsStore.longDateFormat.L}
              placeholder={this.props.translationsStore.longDateFormat.L}
            />
          )}

          {this.Step_1RquiredBasicInputField('car.registrationOdometer', t['shared']['lblInitialOdo'], {
            type: 'number',
            onChange: this.handlerOnChangeRegistrationOdometer
          })}

          {this.withDecorator('car.color', t['shared']['lblColor'], {
            rules: [this.requiredRule(t['shared']['lblColor'])]
          })(
            <SelectOptions
              style={{ minWidth: '174px' }}
              placeholder={t['shared']['lblColor']}
              onChange={value => {
                this.handlerOnChange('car.color')(value);
                this.setState({ showOtherColorInput: value === 'other' });
              }}
              options={vehicleColors}
              optionValue={'type'}
              optionContent={'name'}
            />
          )}
          {this.state.showOtherColorInput &&
            this.Step_1RquiredBasicInputField('car.otherColor', t['shared']['lblOtherColor'], {
              type: 'string',
              onChange: this.handlerOnChangeOtherColor
            })}
        </Row>

        <FormButtons
          noPreviousButton
          submitColSpan="5"
          justify="center"
          lblContinue={t['shared']['btnContinue']}
          isValid={() => true}
          inProgress={step1RegistrationStore.inProgress}
        />
      </Form>
    );
  }
}

export default Form.create()(Step_1_Form);



// WEBPACK FOOTER //
// ./src/components/RegistrationSteps/Step_1/Step_1_Form.js